import { render, staticRenderFns } from "./payment_descriptions_editor.vue?vue&type=template&id=f078ea54&scoped=true"
import script from "./payment_descriptions_editor.vue?vue&type=script&lang=js"
export * from "./payment_descriptions_editor.vue?vue&type=script&lang=js"
import style0 from "./payment_descriptions_editor.vue?vue&type=style&index=0&id=f078ea54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f078ea54",
  null
  
)

export default component.exports